import { render } from "./createReserveComponent.vue?vue&type=template&id=53144cd4"
import script from "./createReserveComponent.vue?vue&type=script&lang=js"
export * from "./createReserveComponent.vue?vue&type=script&lang=js"

import "./createReserveComponent.vue?vue&type=style&index=0&id=53144cd4&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__